// Matriz de permissões espelhada da Doc Funcional v1.0 — Seção 5.
//
// Mapeamento de roles:
//   - REVITER = platform_admin (super-admin da plataforma)
//   - MANAGER = store_owner / store_staff (gerente da loja)
//   - RESELLER = reseller (revendedor numa store RESELLER)
//   - CONSUMER = client (consumidor final)
//
// O frontend usa essas helpers em guards de rota e renderização condicional.
// Não substitui o RBAC do backend — é apenas para UX.

export const ROLE_REVITER = 'platform_admin';
export const ROLE_MANAGER = 'store_owner';
export const ROLE_STAFF = 'store_staff';
export const ROLE_RESELLER = 'reseller';
export const ROLE_CONSUMER = 'client';

export function isReviterAdmin(user) {
  return user?.role === ROLE_REVITER;
}

export function isStoreManager(user) {
  return user?.role === ROLE_MANAGER || user?.role === ROLE_STAFF;
}

export function isReseller(user) {
  return user?.role === ROLE_RESELLER;
}

export function isConsumer(user) {
  return user?.role === ROLE_CONSUMER;
}

export function isBackofficeUser(user) {
  return isReviterAdmin(user) || isStoreManager(user);
}

// Caminho pós-login conforme Seção 10. Usado pelos componentes de login
// (whitelabel /entrar, backoffice /admin-reviter/login e /fornecedor/painel/login).
export function getPostLoginPath(user) {
  if (isReviterAdmin(user)) return '/admin-reviter';
  if (isStoreManager(user)) return '/fornecedor/painel';
  return '/minha-conta';
}

// Permissões compostas (atalho para guards). Nomes em formato verbo:objeto.
const PERMS = {
  'store:manage': isStoreManager,
  'store:create': isReviterAdmin,
  'store:list-all': isReviterAdmin,
  'product:edit': isStoreManager,
  'product:view-cost': isStoreManager,
  'order:fulfill': isStoreManager,
  'order:approve-reseller': isStoreManager,
  'campaign:manage': isStoreManager,
  'reseller:apply': (user) => !!user, // qualquer logado
  'consumer:checkout': () => true,    // anônimo permitido em algumas lojas
};

export function can(user, perm) {
  const fn = PERMS[perm];
  if (!fn) return false;
  return fn(user);
}

const permissions = {
  ROLE_REVITER,
  ROLE_MANAGER,
  ROLE_STAFF,
  ROLE_RESELLER,
  ROLE_CONSUMER,
  isReviterAdmin,
  isStoreManager,
  isReseller,
  isConsumer,
  isBackofficeUser,
  getPostLoginPath,
  can
};

export default permissions;
